import { apiClient } from "./client";

export type PinnedOrg = {
  organization_id: string;
  code: string;
  name: string;
  pinned_at: string;
};

export async function listPinnedOrgs(): Promise<PinnedOrg[]> {
  const { data } = await apiClient.get<PinnedOrg[]>(
    "/api/v1/me/pinned-organizations",
  );
  return data;
}

export async function pinOrg(orgId: string): Promise<PinnedOrg> {
  const { data } = await apiClient.post<PinnedOrg>(
    `/api/v1/me/pinned-organizations/${orgId}`,
  );
  return data;
}

export async function unpinOrg(orgId: string): Promise<void> {
  await apiClient.delete(`/api/v1/me/pinned-organizations/${orgId}`);
}
